<template>
  <div class="layout" id="layout_div" v-if="$store.state?.auth?.me">
    <sidebar></sidebar>
    <top_menu></top_menu>
    <div v-if="$store.state?.auth?.me && ($store.state.auth.me.roles.includes('client_sub') || $store.state.auth.me.roles.includes('client_auth')  || $store.state.auth.me.roles.includes('foreman'))">
      <main_content>
        <div class="router-tab__container" style="padding: 1.5rem">
          <router-view/>
        </div>
      </main_content>
    </div>
    <div v-else>
      <main_content>
        <router-view v-if="$route.meta.forceStandaloneView"/>
        <router-tab v-else restore lang="en" ref="tabs"/>
      </main_content>
    </div>
    <transition name="slide">
      <right_info v-if="$store.state?.right_info?.show"></right_info>
    </transition>
  </div>
  <div v-else/>
</template>
<script>
import sidebar from "components/layouts/sidebar";
import top_menu from "components/layouts/top_menu";
import main_content from "components/layouts/main_content";
import right_info from "components/layouts/right_info";

export default {
  name: 'layout',
  components: {sidebar, main_content, top_menu, right_info},
  computed: {
    right_bar_shown() {
      return this.$store.state?.right_info?.show;
    }
  },
  created() {
    // if (this.$store.state.auth.me.roles && this.$store.state.auth.me.roles.includes('admin') && this.$store.state.auth.me.roles.includes('admin') && false) {
    //   axios.get(this.crmApiPath + 'msgraph/sign_in').then(res => {
    //     if (res.data.is_redirect) {
    //       window.location.href = res.data.redirect_url;
    //     }
    //   })
    // }
  },
  mounted() {
    // if browser is refreshed then check if right bar shown and resize as necessary
    if (this.right_bar_shown) {
      this.$store?.commit('RESIZE_IF_RIGHT_INFO_SHOWN')
    }
    // if browser is refreshed then check if sidebar is expanded and resize as necessary
    if (!this.$store?.state?.sidebar?.collapsed) {
      this.$store.commit('RESIZE_IF_SIDEBAR_EXPANDED');
    }
  }
}
$(document).ready(function () {
  $('[data-toggle="tooltip"]').tooltip();
});
</script>
<style scoped lang="scss">
// Animation transitions for right info component
.slide-enter-active, .slide-leave-active {
  transition: transform 0.2s ease;
}

.slide-enter, .slide-leave-to {
  transform:  translateX(100%);
  transition: all 150ms ease-in 0s
}

.layout {
  min-height:   100vh;
  display:      table;
  overflow-x:   hidden;
  width:        100%;
  max-width:    100%;
  table-layout: fixed;

  &:before, &:after {
    display: table;
    content: " ";
  }

  &:after {
    clear: both;
  }
}
</style>
<style lang="scss">
.content {
  .router-tab__header, .router-tab__scroll {
    height: 35px;
  }
  .router-tab__container {
    border-radius: $border_radius;
    overflow-y:    visible;
    overflow-x:    visible;

    .router-tab-page {
      padding: 10px;
    }
  }

  .router-tab-scroll {
    margin-right: 8px;
    margin-left:  8px;
  }

  .router-tab__item {
    border-top-left-radius:  $border_radius;
    border-top-right-radius: $border_radius;
    background-color:        lighten($main_content_background, 3.5%);
    border-bottom:           none;
    font-size: 11px;

    .router-tab__item-icon {
      font-size: 13px;
    }

    &.is-active {
      background: $bc_3;
      color:      $white;

      .router-tab__item-close:after, .router-tab__item-close:before {
        border-color:     $white;
        background-color: $white;
      }

      &:hover {
        background: $bc_5;

        .router-tab__item-close:after, .router-tab__item-close:before {
          border-color:     #4d4d4d;
          background-color: #4d4d4d;
        }
      }
    }

    .router-tab__item-close {
      &:hover {
        background-color: $bc_2;
        border-radius:    $border-radius_2;
        height:           15px;

        &:after, &:before {
          border-color:     $white !important;
          background-color: $white !important;
        }
      }

    }

    &:hover {
      color:      #4d4d4d;
      background: lighten($bc_1, 42.5%);
    }
  }

  .router-tab__item.is-active .router-tab__item-close, .router-tab__item:hover .router-tab__item-close {
    margin-left: 6px;
  }

  .router-tab__scrollbar-thumb:hover, .router-tab__scrollbar.is-dragging .router-tab__scrollbar-thumb {
    background-color: $bc_1;
  }
}

</style>
